
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import LearningDashboard from './components/LearningDashboard';
import ExerciseSection from './components/ExerciseSection';
import LessonCategories from './components/LessonCategories';

const LearnPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        <LearningDashboard />
        <LessonCategories />
        <ExerciseSection />
      </main>
      <Footer />
    </div>
  );
};

export default LearnPage;
